export default __webpack_public_path__ + "static/media/brickfloor.869c41ea.png";